<template>
  <div class="facilities">
    <div class="pc">
      <div class="banner">
        <img src="img/zbj.png" alt="" />
        <div class="mask">
          <div class="box">Facilities</div>
        </div>
      </div>
      <div class="content">
        <div>
          <img src="img/模具製造.jpg" alt="" />
          <p>Mold manufacturing</p>
        </div>
        <div>
          <img src="img/注塑車間.jpg" alt="" />
          <p>Plastic injection molding</p>
        </div>
        <div>
          <img src="img/cz.jpg" alt="" />
          <p>Pin-insertion</p>
        </div>
        <div>
          <img src="img/zsj.png" alt="" />
          <p>Measurement</p>
        </div>
        <div>
          <img src="img/t2.png" alt="" />
          <p>Clean room</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sw: false,
    };
  },
};
</script>
 
<style lang="less" scoped>
.pc {
  .banner {
    height: 29vw;
    overflow: hidden;
    text-align: center;
    position: relative;
    img {
      width: 120%;
      position: relative;
      top: -15vw;
      left: -15vw;
      z-index: 0;
    }
    .mask {
      position: absolute;
      top: 0;
      background: rgba(15, 15, 15, 0.301);
      width: 100%;
      height: 100%;
      .box {
        position: absolute;
        bottom: 0;
        width: 50%;
        height: 15%;
        left: 0;
        top: 0;
        right: 0;
        margin: auto;
        color: white;
        font-size: 4vw;
        font-weight: 800;
      }
    }
  }
  .content {
    width: 100%;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    > div {
      width: 50%;
      background: white;
      height: 30vw;
      position: relative;
      overflow: hidden;
      img {
        width: 120%;
      }
      p {
        width: 100%;
        position: absolute;
        bottom: 0;
        background: rgba(0, 0, 0, 0.494);
        color: white;
        text-align: center;
        font-size: 1.5vw;
        padding: 0.5vw;
      }
    }
    & > :nth-last-child(1) {
      width: 100%;
      background: red;
      img {
        position: relative;
        top: -10vw;
      }
    }
  }
}
</style>